<template>
  <div class="content conta">
    <h1><span><i class="mdi mdi-cards"></i> Flashcards</span></h1>

    <b-tabs pills nav-class="mb-5 mt-5 " lazy>
    </b-tabs>
  </div>
</template>

<script>
import { TipoPerfilUtil } from '@/core/types/tipo-perfil'
import LoginUtils from '@/core/util/login-utils'

export default {
  name: 'FlashcardsView',
  data () {
    return {
      opcao: ''
    }
  },
  mounted () {
    this.opcao = 'decks'
  },
  computed: {
    perfil: function () {
      return {
        isMaster: TipoPerfilUtil.isMaster(LoginUtils.getUsuario().perfil_id),

        isAdminJaleko: TipoPerfilUtil.isAdminJaleko(LoginUtils.getUsuario().perfil_id),

        isAdmin: TipoPerfilUtil.isAdmin(LoginUtils.getUsuario().perfil_id),

        isAdminRestrito: TipoPerfilUtil.isAdminRestrito(LoginUtils.getUsuario().perfil_id),

        isAnalista: TipoPerfilUtil.isAnalista(LoginUtils.getUsuario().perfil_id),

        isProfessor: TipoPerfilUtil.isProfessor(LoginUtils.getUsuario().perfil_id),

        isEditor: TipoPerfilUtil.isEditor(LoginUtils.getUsuario().perfil_id),

        isAluno: TipoPerfilUtil.isAluno(LoginUtils.getUsuario().perfil_id)
      }
    }
  },
  methods: {
    isActive: function (tab) {
      return this.$route.params.activeTab === tab
    },

    changeRouter: function (tab) {
      this.$router.push(`/conteudo/flashcards/${tab}`)
    }
  }
}
</script>
